import { BaseService } from './../../../core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SalesOrderEftRequestDialogComponent } from '../sales-order-eft-request-dialog/sales-order-eft-request-dialog.component';

@Component({
  selector: 'app-sales-order-add-non-stock-line',
  templateUrl: './sales-order-add-non-stock-line.component.html',
  styleUrls: ['./sales-order-add-non-stock-line.component.scss']
})
export class SalesOrderAddNonStockLineComponent implements OnInit {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<SalesOrderEftRequestDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.form = fb.group({
      salesOrderHeaderId: [null, Validators.compose([Validators.required])],
      lineNumber: [null],
      nonStockCode: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(30)])],
      // nonStockDesc: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
      unitRspIncVat: [null, Validators.compose([Validators.required, Validators.min(1)])],
      qty: [1, Validators.compose([Validators.required])],
    });

    this.form.patchValue(data);
  }

  ngOnInit() {
  }

  save() {
    this.baseService.executeCommand<any>('portal_sales_order_header_add_non_stock_line', this.form.getRawValue())
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        }
      })
  }
}
